export default __webpack_public_path__ + "static/pic-f5999ef8dd476bfbf9d65ddbace7e387.jpg";